import { Route, Routes } from 'react-router-dom';
import DeliveryRequestTrigger from './delivery-request-trigger';
import JotformRelay from './jotform-relay';
import MailAllowlist from './mail-allowlist';

const DevToolsRouting = () => {
  return (
    <Routes>
      <Route path='' element={<DeliveryRequestTrigger />} />
      <Route path='jotform' element={<JotformRelay />} />
      <Route path='email' element={<MailAllowlist />} />
    </Routes>
  );
};

export default DevToolsRouting;
